module.exports = __webpack_public_path__ + "47b2de26eb156bbf7a35ded0bd25e5e9.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/GE.svg
// module id = phcu
// module chunks = 0